import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_mst_pricing_scheme_link_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_pricing_scheme_hdr: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  point_ccy_guid: fromDatatype.GuidDataFieldInterface;
  reward_point: fromDatatype.NumericDatatypeInterface;
  reward_point_enable: boolean;
  reward_point_operator: fromDatatype.VarcharDatatypeInterface;
  reward_point_ratio: fromDatatype.NumericDatatypeInterface;
  redeem_point: fromDatatype.NumericDatatypeInterface;
  redeem_point_enable: boolean;
  redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
  redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  uom: fromDatatype.VarcharDatatypeInterface;
  acl_config: any;
  acl_policy: any;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_mkp_mst_pricing_scheme_link_Rowclass implements bl_mkp_mst_pricing_scheme_link_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_pricing_scheme_hdr: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  point_ccy_guid: fromDatatype.GuidDataFieldInterface;
  reward_point: fromDatatype.NumericDatatypeInterface;
  reward_point_enable: boolean;
  reward_point_operator: fromDatatype.VarcharDatatypeInterface;
  reward_point_ratio: fromDatatype.NumericDatatypeInterface;
  redeem_point: fromDatatype.NumericDatatypeInterface;
  redeem_point_enable: boolean;
  redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
  redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  uom: fromDatatype.VarcharDatatypeInterface;
  acl_config: any;
  acl_policy: any;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
